// @flow

"use strict";

import OuterToInnerDto from "../dto/outer-to-inner-dto";
import InnerToOuterDto from "../dto/inner-to-outer-dto";
import Placement from "../common/placement";
import Environment from "../common/environment";
import Device from "../common/device";
import User from "../common/user";
import OuterWidgetAttribute from "./outer-widget-attribute";
import WidgetInview from "../common/widget-inview";
import Logger from "../common/logger";


export default class OuterWidget {
  constructor(id: string,
              environment: Environment,
              device: Device,
              placement: Placement,
              url: string,
              referer: string,
              user: User,
              attribute: OuterWidgetAttribute,
              inview: WidgetInview) {
    this.id = id; // widget親Div.id
    this.environment = environment; // Environment
    this.device = device; // Device
    this.placement = placement; // Placement
    this.url = url; // 記事URL
    this.referer = referer; // 記事リファラ
    this.user = user; // User
    this.attribute = attribute; // OuterWidgetAttribute
    this.inview = inview; // WidgetInview
  }

  static create(placement: Placement,
                environment: Environment,
                device: Device,
                user: User,
                url: string,
                referrer: string,
                attribute: OuterWidgetAttribute,
                inview: WidgetInview,
                uzouWidgetsLength: number): OuterWidget {
    const widgetId = `uz-${placement.code}-${uzouWidgetsLength}`;

    return new OuterWidget(
      widgetId,
      environment,
      device,
      placement,
      url,
      referrer,
      user,
      attribute,
      inview
    );
  }

  iframeId(): string{
    return `${this.id}-frame`;
  }

  /**
   * WidgetのIframeElementを作成
   * @param window
   * @param doc
   * @returns {Element}
   */
  toIFrameElement(window: Window, doc: HTMLDocument): HTMLIFrameElement{
    const iframe = doc.createElement('iframe');
    iframe.id = this.iframeId();
    iframe.style.height = this.attribute.height;
    iframe.src = `${this.environment.getPlacementTagPath(this.placement, window)}article.html?${OuterToInnerDto.QUERY_KEY()}=${this.toDto().toJsonString()}`;

    return iframe;
  }

  /**
   * フレーム内からのPostMessageを受け取りIframe要素の高さを再設定する
   * @param doc
   */
  resizeHeight(doc: HTMLDocument){
    const iframeParentDiv = doc.getElementById(this.id);
    const iframe = doc.getElementById(this.iframeId());
    const height = this.attribute.height / this.attribute.mediaZoom;
    if (height) {
      iframeParentDiv.style.height = height + "px";
      iframe.style.height = height + "px";
    } else {
      iframeParentDiv.style.display = 'none';
      iframe.style.display = 'none';
    }
  }

  /**
   * Iframe要素の横幅を再設定する
   * @param doc
   * @param width
   */
  resizeWidth(doc: HTMLDocument, width: number){
    const iframeParentDiv = doc.getElementById(this.id);
    const iframe = doc.getElementById(this.iframeId());
    const w = width / this.attribute.mediaZoom;
    if (w) {
      iframeParentDiv.style.width = width + "px";
      iframe.style.width = width + "px";
    }
  }

  /**
   * Inview計測
   * @param window
   * @param doc
   */
  measureInview(window: Window, doc: HTMLDocument){
    if (!this.isInviewPreparation(doc)) {
      return;
    }

    const adTagDiv = doc.getElementById(this.id);
    // なんらかの理由でWidgetの親Divが取得出来なくなった場合はインビュー計測を行わない
    if (!adTagDiv) {
      this.inview.isDone = true;
      window.Uzou.logger.error(new Error(`can not measure widget inview.`));
      return;
    }

    const windowInnerHeight = window.innerHeight; // 画面サイズを取得
    // Inviewの仕様はページ上部から見てWidget全体の30%以上を閲覧した時
    // Iframe親Divのtop絶対座標にpointPixel=widget.height*0.3を足す
    const scrolled = adTagDiv.getBoundingClientRect().top + this.inview.pointPixel;
    // ブラウザの表示域がIframeのTop + Inview判定Pixel数を上回ったらInviewフラグを立てる
    if (windowInnerHeight > scrolled) {
      this.inview.isDone = true;
      // Inview発火scriptTagをiframe親Div直下にappendすることでリクエストを送る
      const script = doc.createElement('script');
      script.async = true;
      script.type = "text/javascript";
      script.src = this.inview.requestURL;
      adTagDiv.appendChild(script);
    }
  }

  /**
   * Inview計測対象フィルター
   * @returns {boolean}
   */
  isInviewPreparation(): boolean {
    return (
      this.attribute.height > 0 &&  // ウィジェット表示している
      this.inview &&  // inviewオブジェクトが存在している
      this.inview.startEnable &&  // inview開始フラグが設定されている
      this.inview.isDone === false &&  // inviewが完了していない
      this.inview.requestURL.length > 0 &&  // inviewのリクエストURLが設定されている
      this.inview.pointPixel > 0  // inview計測ポイントが設定されている
    );
  }

  /**
   * OuterWidget => OuterToInnerDto変換
   * @returns {OuterToInnerDto}
   */
  toDto(): OuterToInnerDto{
    return new OuterToInnerDto(
      this.id,
      this.url,
      this.referer,
      this.device.code,
      this.user.uuid
    );
  }

  /**
   * InnerToOuterDtoから送られてきた値をWidgetにセット
   * @param innerToOuterDto
   */
  receiveDto(innerToOuterDto: InnerToOuterDto){
    this.inview.startEnable = true;
    this.attribute.height = innerToOuterDto.widgetHeight;
    this.user.uuid = innerToOuterDto.uuid;
    this.inview.requestURL = innerToOuterDto.inviewRequestURL;
    this.inview.pointPixel = innerToOuterDto.inviewPointPixel;
  }

}



// WEBPACK FOOTER //
// ./src/js/model/outer/outer-widget.js